import { makeStyles } from "@material-ui/core";
import React, {useRef} from "react";
import "./ToggleBtn.css";

const useStyles = makeStyles();

function ToggleBtn({
  styleType,
  label,
  view,
  handleToggle,
  handleToggleRef,
  toggleState,
  field,
  backgroundStyle,
  externalStyling,
  handleCaching,
  index,
  isSaveTemplate,
  calledFromControlSet
}) {

  const tglRef = useRef(null);

  return (
    <div
      className={
        "toggleBtn" + " " + (externalStyling ? externalStyling.toggle : "")+" control-class"
      }
      style={isSaveTemplate ? externalStyling.container : calledFromControlSet ? {position: 'absolute'} : {}}
    >
      <span>{label}</span>
      <div className="slideBar" style={externalStyling?.quickToolSlideBarStyle || {}}>
        <label
        aria-label="Toggle Button"
        style={calledFromControlSet ? {margin: '0px'} : {}}
        tabIndex={0}
          className={
            "switch" + " " + (externalStyling?.center || "") + (externalStyling?.quickToolSwitchStyle ||  "")
          }
        >
          {((toggleState+"") === "true") 
          ? (
            <input
              aria-label={"Show Progress1"}
              ref={tglRef}
              type="checkbox"
              defaultChecked="true"
              name="showProgress"
              tabIndex={-1}
              checked={true}
              onClick={(e) => {
                handleToggle && handleToggle(e, field);
                handleCaching && handleCaching(index);
              }}
              value={ "false"}
            />
          ) 
          : 
          (
            <input
              aria-label={"Show Progress2"}
              ref={tglRef}
              type="checkbox"
              tabIndex={-1}
              checked={false}
              name="showProgress"
              value={"true"}
              onClick={(e) => {
                handleToggle && handleToggle(e, field);
                handleCaching && handleCaching(index);
              }}
            />
          )}
          <span
          
            className={
              styleType === "2"
                ? "slider2 slider round"
                : "slider round" +
                  " " +
                  (externalStyling ? externalStyling.input : "")
            }
            style={isSaveTemplate ? externalStyling.input : backgroundStyle}
            onClick={(e) => {
              handleToggleRef && handleToggleRef(tglRef, field);
            }}
          ></span>
          {styleType === "3" && <span className="sliderText"></span>}
        </label>
      </div>
    </div>
  );
}

export default ToggleBtn;
